import { APIRequestParams, makeAPIRequest, QueryParams } from '../utils/request'
import { getFirAuth } from '../firebase/firebaseConnect'
import { USER_ENDPOINTS } from '../utils/endpoints'
import { FavoritesProps } from '../../Utils/favorites'
import { getFirUserAndStatus } from '../../Utils/firebaseHelpers'
import { User, UserUpdateData } from './types'
import { MasterLinkParams } from '../../Constant'

type UpdateUserParams = {
  favPlayers?: string[]
  topics?: string[]
  favTeam?: string
  email?: string
  phone?: string
  birthday?: string
  tw?: string
  earlyAccess?: string[]
}

export const getUser = async (linkParams: MasterLinkParams | null) => {
  const { user } = await getFirUserAndStatus()
  let headerParams: QueryParams = {}
  if (user) {
    const token = await user.getIdToken()
    headerParams.Authorization = `Bearer ${token}`
  }
  let requestObj: APIRequestParams = {
    method: 'GET',
    apiVersion: '4',
    headerParams: headerParams,
  }
  if (Object.keys(linkParams || {}).length > 0) {
    requestObj.queryParams = {
      ...linkParams,
    }
  }
  const response = await makeAPIRequest(USER_ENDPOINTS.GET_OR_CREATE_USER, requestObj)
  if (response?.error) {
    console.error(response.error?.message)
    return null
  }
  return response?.data
}

export const createUser = async (data: User, linkParams: MasterLinkParams | null) => {
  const { user } = await getFirUserAndStatus()
  let headerParams: QueryParams = {}
  if (!user) {
    return Promise.resolve(null)
  }
  const token = await user.getIdToken()
  headerParams.Authorization = `Bearer ${token}`
  if (linkParams) {
    data = { ...data, ...linkParams }
  }
  let body = JSON.stringify(data)
  const response = await makeAPIRequest(USER_ENDPOINTS.GET_OR_CREATE_USER, {
    method: 'POST',
    apiVersion: '4',
    headerParams: headerParams,
    body: body,
  })
  if (response?.error) {
    console.error(response.error?.message)
    return null
  }
  return response?.data
}

export const updateUser = async (data: UserUpdateData) => {
  const usr = (await getFirAuth())?.currentUser
  let headerParams: QueryParams = {}
  if (usr) {
    const token = await usr.getIdToken()
    headerParams.Authorization = `Bearer ${token}`
  }
  let body = JSON.stringify(data)
  const response = await makeAPIRequest(USER_ENDPOINTS.UPDATE_USER, {
    method: 'PUT',
    apiVersion: '4',
    headerParams: headerParams,
    body: body,
  })
  if (response?.error) {
    console.error(response.error?.message)
    return data
  }
  return response?.data
}

export const updateFavoritesArray = async ({
  favType,
  item,
  favorites,
}: FavoritesProps) => {
  let favArr: string[] = favorites
  let follow: boolean = false
  const favorited = favArr.includes(item)
  if (!favorited) {
    favArr = [...favArr, item]
    follow = true
  } else {
    const idx = favArr.indexOf(item)
    if (idx !== -1) {
      favArr.splice(idx, 1)
    }
  }
  const data: UpdateUserParams = {}
  if (favType !== 'favTeam') {
    data[favType] = favArr
  }
  const success = await updateUser(data)
  return { success, follow, favorites: favArr }
}

export const updateFavoriteTeam = async (team: string) => {
  if (!team) return { success: false, team: null }
  const data: object = {
    favTeam: team,
  }
  const success = await updateUser(data)
  return { success, team: team }
}

export const updateEarlyAccess = async (
  eaItems: string[],
  item: string,
  updateType: 'add' | 'remove'
) => {
  if (updateType === 'remove' && eaItems.length < 1) {
    console.log('No items to remove')
    return { success: false }
  }
  if (updateType === 'add' && eaItems.includes(item)) {
    console.log('Item already exists')
    return { success: false }
  }
  if (updateType === 'remove') {
    const idx = eaItems.indexOf(item)
    if (idx !== -1) {
      eaItems.splice(idx, 1)
    }
  }
  if (updateType === 'add') {
    eaItems = [...eaItems, item]
  }
  const data: object = {
    earlyAccess: eaItems,
  }
  const success = await updateUser(data)
  return { success }
}
